import React, { useState, useEffect } from 'react';
import './Navigation.css';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'Início', href: '#hero' },
    { name: 'Novidades', href: '#highlights' },
    { name: 'Esculturas', href: '#gallery' },
    { name: 'Música', href: '#music' },
    { name: 'Audiovisual', href: '#audiovisual' },
    { name: 'Textos', href: '#written-works' },
    { name: 'Projetos', href: '#projects' },
    { name: 'Trajetória', href: '#biography' },
    { name: 'Contato', href: '#contact' }
  ];

  const scrollToSection = (href) => {
    const element = document.getElementById(href.substring(1));
    if (element) element.scrollIntoView({ behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={`navigation ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="nav-content">
          <div className="nav-brand">
            <a href="#hero" onClick={(e) => { e.preventDefault(); scrollToSection('#hero'); }}>
              <span className="brand-text">Varella</span>
              <span className="brand-subtitle">Sambista · Escultor · Poeta</span>
            </a>
          </div>

          <div className={`nav-menu ${isMobileMenuOpen ? 'open' : ''}`}>
            <ul className="nav-list">
              {navItems.map((item, index) => (
                <li key={index} className="nav-item">
                  <a
                    href={item.href}
                    className="nav-link"
                    onClick={(e) => { e.preventDefault(); scrollToSection(item.href); }}
                  >
                    {item.name}
                  </a>
                </li>
              ))}
              <li className="nav-item nav-item-cta">
                <a
                  href="#contact"
                  className="nav-cta"
                  onClick={(e) => { e.preventDefault(); scrollToSection('#contact'); }}
                >
                  Contratar
                </a>
              </li>
            </ul>
          </div>

          <button
            className={`nav-toggle ${isMobileMenuOpen ? 'open' : ''}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Abrir menu"
            aria-expanded={isMobileMenuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
